import { tinaClient, useTina, useGetCollection, ANIMATED_CARD } from "@/utils";
import { Page, Header, Section, Card } from "@/components";
import { motion } from "framer-motion";

export default function Resources({ resourcePageQuery, resourceListQuery }) {
  const { data } = useTina({
    ...resourcePageQuery,
  });

  const { seo, header } = data.resourcesPage;
  let resourcesToShow = useGetCollection(resourceListQuery?.data?.resourceConnection);
  const AnimatedCard = motion.create(Card);

  return (
    <Page seo={seo}>
      <Header header={header} breadCrumb="Patient Learning Centre" variant="collection" />
      <Section className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 pt-12 pb-16 lg:pb-24 gap-8">
        {resourcesToShow.map((resource, index) => {
          return (
            <AnimatedCard
              key={index}
              href={`/resources/${resource?._sys.filename}`}
              title={resource?.title}
              image={resource?.image}
              description={resource?.summary}
              button={{
                label: "View Resource",
                link: `/resources/${resource?._sys.filename}`,
              }}
              initial="hide"
              whileInView="show"
              viewport={{ once: true, amount: 0.25 }}
              variants={ANIMATED_CARD((index % 3) * 0.1)}
              draft={!resource?.published}
            />
          );
        })}
      </Section>
    </Page>
  );
}

export const getStaticProps = async ({ preview }) => {
  const resourcePageQuery = await tinaClient.queries.resourcesPage({
    relativePath: "resources-page.mdx",
  });

  let filter = {
    published: { eq: true },
  };

  if (preview) {
    filter = {};
  }

  const resourceListQuery = await tinaClient.queries.resourceList({
    filter: filter,
  });

  return {
    props: {
      resourcePageQuery,
      resourceListQuery,
    },
  };
};
